import React from 'react';

export interface PromotionRuleProductDisplay {
  productId: number;
  variantId?: number;
  name: string;
  sku?: string;
}

interface PromotionRuleProductsProps {
  products: PromotionRuleProductDisplay[];
}

export function PromotionRuleProducts({ products }: PromotionRuleProductsProps) {
  if (products.length === 0) {
    return <span style={{ color: 'var(--text-muted)' }}>None</span>;
  }

  const countLabel = `${products.length} product${products.length === 1 ? '' : 's'}`;

  return (
    <div className="promotion-rule-products">
      <span className="promotion-rule-products-count">{countLabel}</span>
      <ul
        className={`promotion-rule-products-list${
          products.length > 3 ? ' scrollable' : ''
        }`}
      >
        {products.map((product) => (
          <li
            key={product.variantId ? `v-${product.variantId}` : `p-${product.productId}`}
            className="promotion-rule-product-name"
            title={product.sku ? `SKU: ${product.sku}` : undefined}
          >
            {product.name}
          </li>
        ))}
      </ul>
    </div>
  );
}
